/** Soft-hide join packages that should not appear on local camps (ops data cleanup). */

function normalizePackageKey(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

/** Match Invincible11 / Special 11 style join packages by name. */
export function isInvincible11Package(pkg) {
  const key = normalizePackageKey(pkg?.name || pkg?.title || '');
  if (!key) return false;
  return (
    key.includes('invincible11') ||
    key.includes('invinciblespecial11') ||
    key === 'special11' ||
    key === 'invincible11'
  );
}

function collectTrekTypeLabels(trek) {
  const labels = [];
  const push = (v) => {
    const s = String(v || '').trim();
    if (s) labels.push(s);
  };
  push(trek?.eventType?.name);
  push(trek?.category?.name);
  push(trek?.refundCalculatorCategory?.name);
  if (Array.isArray(trek?.eventTypeNames)) trek.eventTypeNames.forEach(push);
  if (Array.isArray(trek?.eventTypes)) {
    trek.eventTypes.forEach((et) => push(et?.name));
  }
  return labels;
}

/** True when trek is tagged as a local camp (event type / campsite / refund category). */
export function isLocalCampTrek(trek) {
  if (!trek) return false;
  return collectTrekTypeLabels(trek).some((label) => /local\s*camp/i.test(label));
}

/** Drop Invincible11 packages on local-camp treks only. */
export function filterPackagesForLocalCamps(packages, trek) {
  const list = Array.isArray(packages) ? packages : [];
  if (!isLocalCampTrek(trek)) return list;
  return list.filter((p) => !isInvincible11Package(p));
}
